module.exports = __webpack_public_path__ + "static/media/integration.7b3cc1f4.png";